var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.condition,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.HtmbGl_add),
      expression: "HtmbGl_add"
    }]
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("合同模板管理-新增")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "3%"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "40px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "10px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "员工合同模板名称",
      "prop": "input"
    }
  }, [_c('el-input', {
    staticStyle: {
      "margin-left": "10px",
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入模板名称"
    },
    model: {
      value: (_vm.condition.input),
      callback: function($$v) {
        _vm.$set(_vm.condition, "input", $$v)
      },
      expression: "condition.input"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同员工分类",
      "prop": "dictionaries_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-left": "10px",
      "width": "160px"
    },
    attrs: {
      "placeholder": "请选择分类"
    },
    model: {
      value: (_vm.condition.dictionaries_id),
      callback: function($$v) {
        _vm.$set(_vm.condition, "dictionaries_id", $$v)
      },
      expression: "condition.dictionaries_id"
    }
  }, _vm._l((_vm.staffList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "生效日期",
      "prop": "riqi"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px",
      "margin-left": "10px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.condition.riqi),
      callback: function($$v) {
        _vm.$set(_vm.condition, "riqi", $$v)
      },
      expression: "condition.riqi"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-right": "100px",
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.cun()
      }
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), [_c('div', {
    staticClass: "edit_container"
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "options": _vm.editorOption
    },
    on: {
      "blur": function($event) {
        return _vm.onEditorBlur($event)
      },
      "focus": function($event) {
        return _vm.onEditorFocus($event)
      },
      "change": function($event) {
        return _vm.onEditorChange($event)
      }
    },
    model: {
      value: (_vm.condition.content),
      callback: function($$v) {
        _vm.$set(_vm.condition, "content", $$v)
      },
      expression: "condition.content"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ql-editor",
    domProps: {
      "innerHTML": _vm._s(_vm.str)
    }
  }, [_vm._v("\n              " + _vm._s(_vm.str) + "\n            ")])], 1)]], 2)], 1)])], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0e18b82","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ygdagl/HtmbGl/HtmbGl_add.vue
// module id = null
// module chunks = 